var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 6.66683H14.1663V3.3335H0.833008V14.1668H2.49967C2.49967 15.5502 3.61634 16.6668 4.99967 16.6668C6.38301 16.6668 7.49967 15.5502 7.49967 14.1668H12.4997C12.4997 15.5502 13.6163 16.6668 14.9997 16.6668C16.383 16.6668 17.4997 15.5502 17.4997 14.1668H19.1663V10.0002L16.6663 6.66683ZM4.99967 15.4168C4.30801 15.4168 3.74967 14.8585 3.74967 14.1668C3.74967 13.4752 4.30801 12.9168 4.99967 12.9168C5.69134 12.9168 6.24967 13.4752 6.24967 14.1668C6.24967 14.8585 5.69134 15.4168 4.99967 15.4168ZM12.4997 5.8335H10.833V11.6668H9.16634V5.8335H7.49967V11.6668H5.83301V5.8335H4.16634V11.6668H2.49967V5.00016H12.4997V5.8335ZM14.9997 15.4168C14.308 15.4168 13.7497 14.8585 13.7497 14.1668C13.7497 13.4752 14.308 12.9168 14.9997 12.9168C15.6913 12.9168 16.2497 13.4752 16.2497 14.1668C16.2497 14.8585 15.6913 15.4168 14.9997 15.4168ZM14.1663 10.0002V7.91683H16.2497L17.883 10.0002H14.1663Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleCargo);
export default __webpack_public_path__ + "static/media/vehicle-cargo.25605db0d3f84259d943c09e2fdc2eae.svg";
export { ForwardRef as ReactComponent };